import confetti from 'canvas-confetti';

// Paleta del ejemplo "Side Cannons" de MagicUI (morado, rosa, naranja, crema).
// El design system no define tokens para partículas de confeti (no son CSS),
// así que se documentan aquí como constante. Cambiar por colores de marca si
// se quisiera alinear con el branding.
const SIDE_CANNON_COLORS = ['#a786ff', '#fd8bbc', '#eca184', '#f8deb1'];

// El canvas de confeti debe quedar por encima del modal (Dialog usa z-index
// 50). Alineado con la escala de z-index del design system ($z-toast: 900):
// una celebración se pinta por encima del modal.
const CONFETTI_Z_INDEX = 900;

/**
 * Duración total del "lanzamiento" (~1,5 s), repartida en dos fases: primero
 * dispara el cañón izquierdo y, pasada la mitad, releva el derecho.
 */
const DURATION_MS = 1500;
/** Relevo: hasta aquí dispara la izquierda; a partir de aquí, la derecha. */
const SWITCH_MS = DURATION_MS / 2;

/** Config común de cada disparo (idéntica salvo el ángulo y el origen). */
const CANNON_BASE = {
  particleCount: 2,
  spread: 60,
  // Velocidad de salida moderada: suficiente para subir alto sin sentirse
  // "disparado" (el ejemplo de MagicUI usa 60).
  startVelocity: 48,
  // Gravedad baja (< 1): los papelitos suben MÁS ALTO con la misma velocidad y
  // luego flotan hacia abajo despacio. Es la palanca principal de la altura.
  gravity: 0.25,
  // Se frenan un pelín más tarde → cada papelito dura un poco más en el aire.
  decay: 0.92,
  // Vida de cada partícula en frames (default 200): alto para que completen el
  // arco hacia arriba y la caída lenta sin desaparecer a media altura.
  ticks: 450,
  colors: SIDE_CANNON_COLORS,
  zIndex: CONFETTI_Z_INDEX,
  // canvas-confetti respeta prefers-reduced-motion de forma nativa: si el
  // usuario lo tiene activo, no dibuja nada aunque se le llame.
  disableForReducedMotion: true,
} as const;

/**
 * Efecto "Side Cannons" (MagicUI): dispara confeti desde los laterales
 * izquierdo y derecho de la pantalla durante ~3 s.
 *
 * Devuelve una función para cancelar el efecto antes de tiempo (p. ej. al
 * desmontar el componente que lo lanzó): detiene el bucle de disparos y limpia
 * las partículas en vuelo para que no se cuelen sobre la siguiente pantalla.
 */
export function fireSideCannonsConfetti(): () => void {
  const start = performance.now();
  let rafId = 0;

  const frame = () => {
    const elapsed = performance.now() - start;
    if (elapsed > DURATION_MS) return;

    // Cañones anclados abajo (y: 1) disparando hacia arriba. Primera mitad:
    // el de la esquina inferior izquierda (sube hacia la derecha). Segunda
    // mitad: releva el de la esquina inferior derecha (sube hacia la izquierda).
    if (elapsed < SWITCH_MS) {
      void confetti({ ...CANNON_BASE, angle: 70, origin: { x: 0.1, y: 1 } });
    } else {
      void confetti({ ...CANNON_BASE, angle: 110, origin: { x: 0.9, y: 1 } });
    }

    rafId = requestAnimationFrame(frame);
  };

  frame();

  return () => {
    if (rafId) cancelAnimationFrame(rafId);
    confetti.reset();
  };
}
